var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84334 2.10319L6.66656 1.92642L6.48979 2.10319L3.71979 4.87319C3.67242 4.92056 3.59071 4.92056 3.54334 4.87319C3.49597 4.82583 3.49597 4.74412 3.54334 4.69675L6.57834 1.66175C6.62571 1.61438 6.70742 1.61438 6.75479 1.66175L9.78979 4.69675C9.83715 4.74412 9.83715 4.82583 9.78979 4.87319L9.78968 4.87309L9.7838 4.87939C9.76867 4.8956 9.73924 4.90997 9.70156 4.90997C9.66929 4.90997 9.63898 4.89884 9.61334 4.87319L6.84334 2.10319Z",
    fill: "#12B76A",
    stroke: "#12B76A",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 10.375C6.60104 10.375 6.54297 10.3169 6.54297 10.25V1.83496C6.54297 1.76803 6.60104 1.70996 6.66797 1.70996C6.7349 1.70996 6.79297 1.76803 6.79297 1.83496V10.25C6.79297 10.3169 6.7349 10.375 6.66797 10.375Z",
    fill: "#12B76A",
    stroke: "#12B76A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp2);
export default __webpack_public_path__ + "static/media/arrow-up2.dc2ec7e6a2f21b1e0c7dbd43bb082985.svg";
export { ForwardRef as ReactComponent };